import React from 'react';
import {
    Box,
    Typography,
    Paper,
    IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function OSHAGuidelines() {
    const navigate = useNavigate();

    return (
        <Box sx={{ 
            position: 'fixed',
            top: '60px',
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex', 
            flexDirection: 'column',
            backgroundColor: 'background.default'
        }}>
            {/* Header */}
            <Box 
                sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    borderBottom: 1,
                    borderColor: 'divider',
                    backgroundColor: 'background.paper'
                }}
            >
                <IconButton onClick={() => navigate('/')} edge="start">
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" fontWeight={600} sx={{ ml: 1 }}>
                    When OSHA/DHEC Arrives on Site
                </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, p: 2, overflow: 'auto' }}>
                <Paper sx={{ p: 3 }}>
                    <Typography variant="body1" component="div" sx={{ whiteSpace: 'pre-line' }}>
                        <Box component="span" sx={{ fontWeight: 'bold' }}>1. Call the Safety Director immediately – Joey Loftis (864) 764-5341</Box>
                        {'\n'}• This needs to be the FIRST point of contact
                        {'\n'}• You are entitled to representation
                        {'\n'}Be cooperative and inform the officer that the company policy is to notify the main office when an OSHA/DHEC inspector arrives on site
                        {'\n\n'}
                        <Box component="span" sx={{ fontWeight: 'bold' }}>2. Ask and let them tell you why they are there (With Diplomacy and Professionalism)</Box>
                        {'\n'}• Provide only the information they ask for
                        {'\n'}• DO NOT volunteer information or provide answers to questions that you are unsure of
                        {'\n\n'}
                        <Box component="span" sx={{ fontWeight: 'bold' }}>3. Leading Supervisor must accompany the OSHA/DHEC inspector during the walk around</Box>
                        {'\n'}• If the inspector takes a picture, take the same picture
                        {'\n'}• If the inspector makes a note, make that note as well
                        {'\n'}• Take recommended corrective action immediately - Show a desire to cooperate
                        {'\n'}Be aware that the compliance officer determines the route and duration of the inspection
                        {'\n\n'}
                        <Box component="span" sx={{ fontWeight: 'bold' }}>4. Take notes in the closing conference</Box>
                        {'\n'}• Take detailed notes at the closing conference, which will be held after the inspection, at which time all items observed during the inspection will be discussed and an abatement date will be set.
                        {'\n'}• Be sure the officer lists and indicates all apparent violations for which a citation and a proposed penalty may be issued or recommended.
                        {'\n'}• Post a copy of each citation at or near the place the violation occurred for three days, or until the violation is abated, whichever is longer.
                        {'\n'}• Never argue with the OSHA/DHEC inspector; always be courteous and polite.
                        {'\n\n'}
                        <Box component="span" sx={{ fontWeight: 'bold' }}>The process of OSHA/DHEC inspections are as follows:</Box>
                        {'\n'}1. Opening Conference
                        {'\n'}2. Walk Around
                        {'\n'}3. Closing Conference
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
}